const initProductFilters = () => {
    const sidebar = document.querySelector('.FilterSidebar');
    const backdrop = document.querySelector('.FilterSidebarBackdrop');
    const openButtons = Array.from(document.querySelectorAll('.toggle-filters'));

    if (!sidebar || !backdrop || openButtons.length === 0) {
        return;
    }

    const form = sidebar.querySelector('#product-filter-form');
    const closeButtons = Array.from(sidebar.querySelectorAll('[data-filter-close]'));
    const selectionTotal = sidebar.querySelector('[data-filter-selection-total]');
    const submitButton = sidebar.querySelector('.FilterSidebar__submit');
    let lastFocusedElement = null;

    const getFocusableElements = () =>
        Array.from(
            sidebar.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
            ),
        ).filter((element) => !element.hidden && element.offsetParent !== null);

    const updateSelectionSummary = () => {
        let selectedTotal = 0;

        sidebar.querySelectorAll('[data-filter-section]').forEach((section) => {
            const checkedCount = section.querySelectorAll('input[type="checkbox"]:checked').length;
            const filledPriceCount = Array.from(section.querySelectorAll('input[type="number"]')).filter(
                (input) => input.value.trim() !== '',
            ).length;
            const sectionCount = checkedCount + filledPriceCount;
            const countElement = section.querySelector('[data-filter-selected-count]');

            selectedTotal += sectionCount;

            if (countElement) {
                countElement.textContent = String(sectionCount);
                countElement.classList.toggle('is-empty', sectionCount === 0);
            }
        });

        if (selectionTotal) {
            selectionTotal.textContent = String(selectedTotal);
        }
    };

    const openSidebar = (event) => {
        event?.preventDefault();
        lastFocusedElement = event?.currentTarget || document.activeElement;
        sidebar.classList.add('is-open');
        backdrop.classList.add('is-open');
        sidebar.setAttribute('aria-hidden', 'false');
        sidebar.inert = false;
        document.body.classList.add('has-filter-sidebar-open');
        openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));

        window.requestAnimationFrame(() => {
            sidebar.querySelector('.FilterSidebar__close')?.focus();
        });
    };

    const closeSidebar = (event) => {
        event?.preventDefault();
        sidebar.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        sidebar.setAttribute('aria-hidden', 'true');
        sidebar.inert = true;
        document.body.classList.remove('has-filter-sidebar-open');
        openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));

        if (lastFocusedElement instanceof HTMLElement) {
            lastFocusedElement.focus();
        }
    };

    sidebar.inert = true;
    openButtons.forEach((button) => button.addEventListener('click', openSidebar));
    closeButtons.forEach((button) => button.addEventListener('click', closeSidebar));
    backdrop.addEventListener('click', closeSidebar);

    sidebar.querySelectorAll('[data-filter-toggle]').forEach((button) => {
        const contentId = button.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;

        if (!content) {
            return;
        }

        button.addEventListener('click', () => {
            const willExpand = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(willExpand));
            content.hidden = !willExpand;
        });
    });

    sidebar.querySelectorAll('[data-filter-more]').forEach((button) => {
        const section = button.closest('[data-filter-section]');
        const label = button.querySelector('[data-filter-more-label]');

        button.addEventListener('click', () => {
            const willShowAll = !section.classList.contains('is-showing-all');
            section.classList.toggle('is-showing-all', willShowAll);
            button.setAttribute('aria-expanded', String(willShowAll));

            if (label) {
                label.textContent = willShowAll ? 'Pokaż mniej' : 'Pokaż więcej';
            }
        });
    });

    sidebar.querySelectorAll('[data-filter-search]').forEach((input) => {
        const section = input.closest('[data-filter-section]');
        const options = Array.from(section.querySelectorAll('[data-filter-option]'));
        const moreButton = section.querySelector('[data-filter-more]');

        input.addEventListener('input', () => {
            const query = input.value.trim().toLocaleLowerCase('pl');

            options.forEach((option) => {
                const label = option.dataset.filterLabel || '';
                option.classList.toggle('is-search-hidden', query !== '' && !label.includes(query));
            });

            if (query !== '') {
                section.classList.add('is-showing-all');
            }

            if (moreButton) {
                moreButton.hidden = query !== '';
            }
        });
    });

    form?.addEventListener('change', updateSelectionSummary);
    form?.addEventListener('input', (event) => {
        if (event.target.matches('input[type="number"]')) {
            event.target.setCustomValidity('');
            updateSelectionSummary();
        }
    });

    form?.addEventListener('reset', (event) => {
        event.preventDefault();

        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
            input.checked = false;
        });
        form.querySelectorAll('input[type="number"], input[type="search"]').forEach((input) => {
            input.value = '';
            input.setCustomValidity('');
        });
        form.querySelectorAll('[data-filter-option]').forEach((option) => {
            option.classList.remove('is-search-hidden');
        });
        form.querySelectorAll('[data-filter-more]').forEach((button) => {
            button.hidden = false;
        });

        updateSelectionSummary();
    });

    form?.addEventListener('submit', (event) => {
        const minimumInput = form.querySelector('input[name="min_price"]');
        const maximumInput = form.querySelector('input[name="max_price"]');
        const minimum = minimumInput?.value !== '' ? Number(minimumInput.value) : null;
        const maximum = maximumInput?.value !== '' ? Number(maximumInput.value) : null;

        if (minimum !== null && maximum !== null && minimum > maximum) {
            event.preventDefault();
            maximumInput.setCustomValidity('Cena maksymalna musi być wyższa od minimalnej.');
            maximumInput.reportValidity();
            maximumInput.focus();
            return;
        }

        form.querySelectorAll('input[type="number"]').forEach((input) => {
            input.disabled = input.value.trim() === '';
        });

        if (submitButton) {
            submitButton.classList.add('is-loading');
            submitButton.disabled = true;
            submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Ładowanie…'));
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!sidebar.classList.contains('is-open')) {
            return;
        }

        if (event.key === 'Escape') {
            closeSidebar(event);
            return;
        }

        if (event.key !== 'Tab') {
            return;
        }

        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) {
            event.preventDefault();
            return;
        }

        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    updateSelectionSummary();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFilters, { once: true });
} else {
    initProductFilters();
}
